import React, {useRef} from 'react';
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Paginator} from "primereact/paginator";
import {ConfirmDialog, confirmDialog} from "primereact/confirmdialog";
import {webInfo} from "../../../../utils/webInfo";
import {Button} from "primereact/button";
import {Link} from "react-router-dom";
import callToast, {catchError} from "../../../../utils/helper";
import useDelete from "../../../../hooks/useDelete";
import {Toast} from "primereact/toast";
import {Skeleton} from "primereact/skeleton";
import {InputSwitch} from "primereact/inputswitch";
import usePost from "../../../../hooks/usePost";

const HumanTable = ({products, total, onPageChange, page, perPage, categories, update, setUpdate}: any) => {

    const {post, loading: ploading} = usePost()
    const {remove, loading: rloading} = useDelete();
    const toast = useRef<any>(null);

    const imageBodyTemplate = (rowData: any) => (
        <img
            src={`${webInfo.baseUrl}/${rowData.thumbnail_image}`}
            alt={rowData.name}
            style={{width: "30px", height: "30px", borderRadius: "6px", objectFit: 'cover'}}
        />
    );

    const brandBodyTemplate = (rowData: any) => {
        const div = `products-human`;
        const link = `/products/${rowData.id}?url=${div}&division=8`;

        return (
            <div>
                <Link className="text-gray-900 underline" style={{cursor: "pointer"}} to={link}>
                    {rowData?.brand_name}
                </Link>
            </div>
        );
    };

    const divisionBodyTemplate = () => (
        <span>Chemist Laboratories</span>
    );

    const categoryBodyTemplate = (rowData: any) => {
        const category = categories.find((e: any) => Number(e.code) === Number(rowData?.product_human_category_id));
        return <span>{category?.name}</span>;
    };

    const pdfBodyTemplate = (rowData: any) => {
        if (!rowData.details_pdf) {
            return <span className="text-red-600">No File</span>;
        }

        return (
            <a
                href={`${webInfo.baseUrl}/${rowData.details_pdf}`}
                target="_blank"
                rel="noopener noreferrer"
            >
                <Button
                    outlined
                    label="View PDF"
                    icon="pi pi-file-pdf"
                    className="p-button-sm"
                />
            </a>
        );
    };

    const removeProduct = async (id: any) => {
        const deleteUrl = `${webInfo.baseUrl}/api/admin/products-human/${id}`;
        try {
            const res: any = await remove(deleteUrl);
            if (res.success) {
                setUpdate(!update);
            } else {
                callToast(toast, false, res.error.message);
            }
        } catch (e) {
            catchError(e);
        }
    };

    const confirmRemoveProduct = (id: any) => {
        confirmDialog({
            message: "Are you sure you want to delete this product?",
            header: "Delete Confirmation",
            icon: "pi pi-exclamation-triangle",
            acceptClassName: "p-button-danger",
            accept: () => removeProduct(id),
        });
    };

    const actionBodyTemplate = (rowData: any) => {

        return (
            <div className="flex gap-2">
                {/*<Button*/}
                {/*    icon="pi-info"*/}
                {/*    title="Details"*/}
                {/*    className="p-button-sm"*/}
                {/*    onClick={() =>*/}
                {/*        navigate(`/products/${rowData.id}?url=products-human&division=8`)*/}
                {/*    }*/}
                {/*/>*/}

                <Button
                    icon="pi pi-trash"
                    title="Remove"
                    className="p-button-sm p-button-danger"
                    loading={rloading}
                    onClick={() => confirmRemoveProduct(rowData.id)}
                />
            </div>
        );
    };

    const publishStatus = (rowData: any) => {
        const statusUpdateUrl = `${webInfo.baseUrl}/api/admin/products-human/${rowData?.id}/publish-status`
        const updateStatus = async (rowData: any) => {
            const payload = {
                status: Number(rowData.status) === 1 ? 0 : 1,
            }
            try {
                const res: any = await post(statusUpdateUrl, true, payload)
                if (res.success) {
                    setUpdate(!update);
                }
            } catch (e) {
                catchError(e)
            }
        }

        if (ploading) {
            return <Skeleton width={"4rem"} height={"2.5rem"}></Skeleton>
        }
        return <div className="flex gap-2 justify-content-start">
            <InputSwitch checked={Number(rowData?.status) === 1} onChange={() => updateStatus(rowData)}/>
        </div>
    }

    return (
        <div>
            <Toast ref={toast}/>
            <ConfirmDialog/>
            <DataTable
                value={products}
                // responsiveLayout="scroll"
            >
                <Column header="Image" body={imageBodyTemplate}/>
                <Column body={brandBodyTemplate} header="Brand"/>
                <Column field="generic_name" header="Generic Name"/>
                <Column header="Division" body={divisionBodyTemplate}/>
                <Column header="Category" body={categoryBodyTemplate}/>
                <Column body={publishStatus} header="Publish Status" sortable/>
                <Column header="PDF" body={pdfBodyTemplate}/>
                <Column header="Actions" body={actionBodyTemplate}/>
            </DataTable>

            <Paginator
                first={(page - 1) * perPage}
                rows={perPage}
                totalRecords={total}
                rowsPerPageOptions={[10, 20, 30]}
                onPageChange={onPageChange}
            />
        </div>
    );
};

export default HumanTable;